import { usePropertyMakingStructuralChanges } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

interface MakingStructuralChangesProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const MakingStructuralChanges: React.FC<MakingStructuralChangesProps> = ({ propertyGuid, isReview = false }) => {
    const label = 'Making structural changes?';
    const [makingStructuralChanges, set_makingStructuralChanges] = usePropertyMakingStructuralChanges(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_makingStructuralChanges(true);
                return;
            case 'no':
                set_makingStructuralChanges(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={makingStructuralChanges ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonMakingStructuralChanges'
                    value={makingStructuralChanges}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
